/**
 * Authentication configuration for Portali Online.
 * Initializes @ipsoftsrl/frontend-auth with project-specific settings.
 */

import { initAuth, type AuthConfig } from '@ipsoftsrl/frontend-auth';

const authConfig: AuthConfig = {
  login: {
    projectName: 'Portali Online',
    loginFields: [
      { type: 'email', label: 'Email' },
      { type: 'codice_fiscale', label: 'Codice Fiscale' },
    ],
    labels: {
      title: 'Accedi al Portale Documentale',
      subtitle: 'Accedi ai servizi aziendali',
      identifierPlaceholder: 'Email o Codice Fiscale',
      submitButton: 'Accedi',
      firstAccessButton: 'Primo Accesso',
      forgotPasswordLink: 'Password dimenticata?',
    },
    features: {
      firstAccess: true,
      forgotPassword: true,
      mfa: true,
    },
  },
  cognito: {
    userPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID || 'eu-central-1_07zBBwYFH',
    clientId: import.meta.env.VITE_COGNITO_CLIENT_ID || 'arcomuumti249t4qs8384p2vl',
    region: 'eu-central-1',
  },
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL || '/api',
};

/** Call once at app startup to configure the auth system */
export function setupAuth(): void {
  initAuth(authConfig);
}
